/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import styled from 'styled-components';

const ImageSharp = styled(Img)`
  width: 100%;
  height: 100%;
`;

const QUERY = graphql`
  query {
    filename: file(sourceInstanceName: { eq: "images" }, name: { eq: "menu" }) {
      childImageSharp {
        fluid(maxWidth: 600) {
          ...GatsbyImageSharpFluid_withWebp_noBase64
        }
      }
    }
  }
`;

export const MenuCoverImage = () => {
  //
  const { filename } = useStaticQuery(QUERY);

  return <ImageSharp fluid={filename.childImageSharp.fluid} />;
};
